var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-recaptcha',{attrs:{"sitekey":_vm.sitekey,"loadRecaptchaScript":true},on:{"verify":_vm.onVerify,"expired":_vm.onExpired,"onError":_vm.onError}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }